import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Button, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SelectTypeOfDashboard from "../../../components/Table/Dashboard/SelectTypeOfDashboard";
import { useAllUsersDashboard } from "../../../context/SuperAdmin/DashboardContexts/AllUsers";
import SingleTotalCreditos from "../../../components/Table/Dashboard/SingleEntity/SingleTotalCreditos";
import SingleMonthlyCredits from "../../../components/Table/Dashboard/SingleEntity/SingleMonthlyCredits";

const SingleUserDahsboard = () => {
  const {
    selectedUser,
    isLoadingTotalCredits,
    isLoadingMonthlyCredits,
    monthlyCredits,
    months,
    startMonth,
    monthlyCreditsFilters,
    changeMonths,
    updateStartingMonth,
    handleToggleMonthlyCredit,
  } = useAllUsersDashboard();
  const navigate = useNavigate();

  if (!selectedUser) return;

  return (
    <SelectTypeOfDashboard routeValue="users">
      {/* Header de Single User */}
      <Grid
        container
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        {/* Título */}
        <Grid item>
          <Typography
            variant={"h5"}
            sx={{ color: "#005559", fontSize: "24px" }}
          >
            <b>Usuario</b> | {selectedUser?.email}
          </Typography>
        </Grid>

        {/* Boton para volver */}
        <Grid item>
          <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
            <ArrowBackOutlinedIcon />
            Volver
          </Button>
        </Grid>
      </Grid>

      {/* Pie Charts con el resume de los créditos totales */}
      <SingleTotalCreditos
        credits={selectedUser}
        isLoading={isLoadingTotalCredits}
      />

      {/* Créditos mensuales */}
      <SingleMonthlyCredits
        isLoading={isLoadingMonthlyCredits}
        monthlyCredits={monthlyCredits}
        startMonth={startMonth}
        months={months}
        changeMonths={changeMonths}
        updateStartingMonth={updateStartingMonth}
        creditsFilters={monthlyCreditsFilters}
        handleToggleCredit={handleToggleMonthlyCredit}
      />
    </SelectTypeOfDashboard>
  );
};

export default SingleUserDahsboard;
